import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M20.255 7a89 89 0 0 0-8.77-.438q-2.6 0-5.2.263L4.5 7m4.583-1 .192-1.147C9.415 4.022 9.52 3.4 11 3.4h2.293c1.48 0 1.593.657 1.724 1.462L15.21 6m3.096 1.105-.569 10.489c-.096 1.635-.175 2.906-2.617 2.906H9.5c-2.441 0-2.52-1.27-2.616-2.906l-.57-10.489m4.235 2.88L10.78 17m3.45-7.016L14 17"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnTrash;
